import { Controller } from "@hotwired/stimulus";
import { DirectUpload } from "@rails/activestorage";
import { post } from "@rails/request.js";

// Connects to data-controller="image-upload"
export default class extends Controller {
  static targets = ["input", "preview"];
  static values = { url: String };
  connect() {
    // Initialize the controller
  }

  fileAdded(event) {
    let files = Array.from(event.target.files);
    let directUploadUrl = event.target.dataset["directUploadUrl"];
    files.forEach((file) => {
      let directUpload = new Uploader(file, directUploadUrl, this);
      directUpload.uploadFile(file, this);
    });
  }
}

class Uploader {
  constructor(file, url, controller) {
    this.controller = controller;
    this.upload = new DirectUpload(file, url, controller, this);
  }

  uploadFile(file) {
    this.upload.create(async (error, blob) => {
      if (error) {
        // Handle the error
      } else {
        await post(this.controller.urlValue, {
          body: {
            blob_signed_id: blob.signed_id,
          },
          responseKind: "turbo-stream",
        });
      }
    });
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress", (event) =>
      this.directUploadDidProgress(event)
    );
  }

  directUploadDidProgress(event) {
    // Use event.loaded and event.total to update the progress bar
  }
}
